module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Thin.f878fec5.woff2";